<div class="modal-header">
  <h4 class="modal-title" id="modal-title" style="margin-left: 10px;">Extractor Information </h4>
  <button type="button" class="close text-white" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <div>
    <div style="display: flex;">
      <div class="panel-heading font-bold text-uppercase mb-2">Getting Started</div>
      <div style="margin-left: auto; padding-top: 5px;"><a style="font-size: 1rem;" href="https://relay.corp.adobe.com/#relay/testcase/224189" target="_blank">Sample Testcase</a></div>
    </div>
    <div class="panel-body">JsonPath expressions can use the dot–notation
      <pre class="mt-2">$.store.book[0].title or the bracket–notation $['store']['book'][0]['title']</pre>
    </div>
  </div>

  <hr class="dotted-line">

  <div class="mt-2">
    <div class="panel-heading font-bold text-uppercase">Operators</div>
    <div class="panel-body">
      <div class="table-responsive mt-2">
        <table class="table table-condensed mt-2">
          <tr class="active">
            <th class="table-header">Operator</th>
            <th class="table-header">Description</th>
          </tr>
          <tr>
            <td class="font-bold">$</td>
            <td>The root element to query. This starts all path expressions.</td>
          </tr>
          <tr>
            <td class="font-bold">@</td>
            <td>The current node being processed by a filter predicate.</td>
          </tr>
          <tr>
            <td class="font-bold">*</td>
            <td>Wildcard. Available anywhere a name or numeric are required.</td>
          </tr>
          <tr>
            <td class="font-bold">..</td>
            <td>Deep scan. Available anywhere a name is required.</td>
          </tr>
          <tr>
            <td class="font-bold"> .< name>
            </td>
            <td>Dot-notated child</td>
          </tr>
          <tr>
            <td class="font-bold"> ['< name>' (, '< name>')]</td>
            <td>Bracket-notated child or children</td>
          </tr>
          <tr>
            <td class="font-bold"> [< number> (, < number>)] </td>
            <td>Array index or indexes</td>
          </tr>
          <tr>
            <td class="font-bold"> [start:end] </td>
            <td>Array slice operator</td>
          </tr>
          <tr>
            <td class="font-bold"> [?(< expression>)]</td>
            <td>Filter expression. Expression must evaluate to a boolean value.</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <hr class="dotted-line">

  <div class="mt-2">
    <div class="panel-heading font-bold text-uppercase">Functions</div>
    <div class="mt-2 mb-2">Functions can be invoked at the tail end of a path - the input to a function is the output of the path expression. The function output is dictated by the function itself.</div>
    <div class="panel-body">
      <div class="table-responsive mt-2">
        <table class="table table-condensed">
          <tr class="active">
            <th class="table-header">Function</th>
            <th class="table-header">Description</th>
            <th class="table-header">Output type</th>
          </tr>
          <tr>
            <td class="font-bold">min()</td>
            <td>Provides the min value of an array of numbers.</td>
            <td>Double</td>
          </tr>
          <tr>
            <td class="font-bold">max()</td>
            <td>Provides the max value of an array of numbers.</td>
            <td>Double</td>
          </tr>
          <tr>
            <td class="font-bold">avg()</td>
            <td>Provides the average value of an array of numbers.</td>
            <td>Double</td>
          </tr>
          <tr>
            <td class="font-bold">stddev()</td>
            <td>Provides the standard deviation value of an array of numbers.</td>
            <td>Double</td>
          </tr>
          <tr>
            <td class="font-bold">length()</td>
            <td>Provides the length of an array.</td>
            <td>Integer</td>
          </tr>
          <tr>
            <td class="font-bold">sum()</td>
            <td>Provides the sum value of an array of numbers.</td>
            <td>Double</td>
          </tr>
          <tr>
            <td class="font-bold">keys()</td>
            <td>Provides the property keys (An alternative for terminal tilde ~).</td>
            <td>Set< E>
            </td>
          </tr>
          <tr>
            <td class="font-bold">concat(X)</td>
            <td>Provides a concatinated version of the path output with a new item.</td>
            <td>like input</td>
          </tr>
          <tr>
            <td class="font-bold">append(X)</td>
            <td>Add an item to the json path output array.</td>
            <td>like input</td>
          </tr>
          <tr>
            <td class="font-bold">first()</td>
            <td>Provides the first item of an array.</td>
            <td>Depends on the array</td>
          </tr>
          <tr>
            <td class="font-bold">last()</td>
            <td>Provides the last item of an array.</td>
            <td>Depends on the array</td>
          </tr>
          <tr>
            <td class="font-bold">index(X)</td>
            <td>Provides the item of an array of index: X, if the X is negative, take from backwards.</td>
            <td>Depends on the array</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <hr class="dotted-line">

  <div class="mt-2">
    <div class="panel-heading font-bold text-uppercase">Filter Operators</div>
    <div class="mt-2 mb-2">Filters are logical expressions used to filter arrays. A typical filter would be [?(@.age > 18)] where @ represents the current item being processed. More complex filters can be created with logical operators && and ||. String literals must be enclosed by single or double quotes ([?(@.color == 'blue')] or [?(@.color == "blue")]).</div>
    <div class="panel-body">
      <div class="table-responsive mt-2">
        <table class="table table-condensed">
          <tr class="active">
            <th class="table-header">Function</th>
            <th class="table-header">Description</th>
          </tr>
          <tr>
            <td class="font-bold"> == </td>
            <td>left is equal to right (note that 1 is not equal to '1') </td>
          </tr>
          <tr>
            <td class="font-bold"> != </td>
            <td> left is not equal to right </td>
          </tr>
          <tr>
            <td class="font-bold"> &lt; </td>
            <td> left is less than right </td>
          </tr>
          <tr>
            <td class="font-bold"> &lt;= </td>
            <td> left is less or equal to right </td>
          </tr>
          <tr>
            <td class="font-bold"> &gt; </td>
            <td> left is greater than right </td>
          </tr>
          <tr>
            <td class="font-bold"> &gt;= </td>
            <td> left is greater than or equal to right </td>
          </tr>
          <tr>
            <td class="font-bold"> =~ </td>
            <td> left matches regular expression [?(@.name =~ /foo.*?/i)] </td>
          </tr>
          <tr>
            <td class="font-bold"> in </td>
            <td> left exists in right [?(@.size in ['S', 'M'])] </td>
          </tr>
          <tr>
            <td class="font-bold"> nin </td>
            <td> left does not exists in right </td>
          </tr>
          <tr>
            <td class="font-bold"> subsetof </td>
            <td> left is a subset of right [?(@.sizes subsetof ['S', 'M', 'L'])] </td>
          </tr>
          <tr>
            <td class="font-bold"> anyof </td>
            <td> left has an intersection with right [?(@.sizes anyof ['M', 'L'])] </td>
          </tr>
          <tr>
            <td class="font-bold"> noneof </td>
            <td> left has no intersection with right [?(@.sizes noneof ['M', 'L'])] </td>
          </tr>
          <tr>
            <td class="font-bold"> size </td>
            <td> size of left (array or string) should match right </td>
          </tr>
          <tr>
            <td class="font-bold"> empty </td>
            <td> left (array or string) should be empty </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <hr class="dotted-line">

  <div class="mt-2">
    <div class="panel-heading font-bold text-uppercase">Path Examples</div>
    <div class="mt-4 mb-2">Given the json</div>
    <div class="panel-body">
      <div contenteditable="false" class="editable">
        <pre *ngFor="let item of extractorExampleSplit" class="ml-2"><span *ngIf="item[0] === '#'" style="color: rgb(170, 169, 169)">{{item}}</span><span *ngIf="item[0] !== '#'" style="color: rgb(255, 253, 253)">{{item}}</span><br /></pre>
      </div>
    </div>
    <div class="panel-body">
      <div class="table-responsive mt-4">
        <table class="table table-condensed">
          <tr class="active">
            <th class="table-header">JsonPath</th>
            <th class="table-header">Result</th>
          </tr>
          <tr>
            <td class="font-bold"> $.store.book[*].author </td>
            <td> The authors of all books </td>
          </tr>
          <tr>
            <td class="font-bold"> $..author </td>
            <td> All authors </td>
          </tr>
          <tr>
            <td class="font-bold"> $.store.* </td>
            <td> All things, both books and bicycles </td>
          </tr>
          <tr>
            <td class="font-bold"> $.store..price </td>
            <td> The price of everything </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[2] </td>
            <td> The third book </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[-2] </td>
            <td> The second to last book </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[0,1] </td>
            <td> The first two books </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[:2] </td>
            <td> All books from index 0 (inclusive) until index 2 (exclusive) </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[1:2] </td>
            <td> All books from index 1 (inclusive) until index 2 (exclusive) </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[-2:] </td>
            <td> Last two books </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[2:] </td>
            <td> All books from index 2 (inclusive) to last </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[?(@.isbn)] </td>
            <td> All books with an ISBN number </td>
          </tr>
          <tr>
            <td class="font-bold"> $.store.book[?(@.price &lt; 10)] </td>
            <td> All books in store cheaper than 10 </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[?(@.price &lt;= $['expensive'])] </td>
            <td> All books in store that are not &quot;expensive&quot; </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book[?(@.author =~ /.*REES/i)] </td>
            <td> All books matching regex (ignore case) </td>
          </tr>
          <tr>
            <td class="font-bold"> $..* </td>
            <td> Give me every thing </td>
          </tr>
          <tr>
            <td class="font-bold"> $..book.length() </td>
            <td> The number of books </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer confirm-footer">
  <!-- buttons for Cancel Confirmation Modal -->
  <!-- <button class="btn btn-primary btn-sm" type="button" (click)="cancel()">Cancel</button> -->
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()"><i class="fas fa-times-circle mr-1"></i> Cancel</button>
</div>
